<template>
  <v-layout>
    <v-row>
      <v-col cols="12">
        <v-select
            class="mt-0 pt-0"
            v-model="standardFilters.status"
            label="Status"
            :items="statuses"
            item-value="value"
            item-text="text"
            hide-details
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.companyName"
            label="Nazwa firmy"
            placeholder=" "
            :counter="100"
            :rules="rules.textFilter"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.nip"
            label="NIP"
            placeholder=" "
            :counter="10"
            :rules="rules.textFilter"
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-if="!this.hideSupervisor">
        <v-select
            :items="supervisors"
            v-model="standardFilters.supervisor"
            label="Opiekun"
            item-value="id"
            solo
            v-bind="attrs"
            v-on="on"
            class="wastemaster-input-elevation"
        >
          <template v-slot:selection="data">
            {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
          </template>
          <template v-slot:item="data">
            {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
          </template>
        </v-select>
      </v-col>
      <v-col cols="12">
        <v-checkbox
            class="mt-0 pt-0"
            v-model="standardFilters.showGuests"
            label="Pokazuj firmy gości"
        />
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-checkbox
            class="mt-0 pt-0"
            v-model="standardFilters.partner"
            label="Tylko Partnerzy"
            hide-details
        />
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.sellWithWm"
            label="Tylko &quot;Sprzedaj z WasteMaster&quot;"
            hide-details
            @click="onSellWithWmSwitched"
        />
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.notSellWithWm"
            label="Tylko standardowe oferty"
            hide-details
            @click="onNotSellWithWmSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Tylko standardowe oferty, czyli takie, które NIE zostały wystawione w programie "Sprzedaj z WasteMaster".
            </v-tooltip>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { getItems as getCompanyStatusItems } from '@/enums/CompanyStatus';
import { getItems as getCompanyTypeItems } from '@/enums/CompanyType';
import {setDatatableFilters} from "@/utils/helpers";
import debounce from "debounce";
import api from "@/services/api";

export default {
  props: {
    hideSupervisor: {
      type: [Boolean],
      required: false,
      default: false
    },
  },
  data() {
    return {
      supervisors: [],
      filterCompaniesDebouncing: null,
      standardFilters: {
        type: '',
        status: '',
        showGuests: false,
        sellWithWm: false,
        notSellWithWm: false,
        partner: false,
        supervisor: null
      },
      debouncedFilters: {
        companyName: '',
        nip: '',
      },
      types: [
        {value: '', text: 'Dowolna'},
        ...getCompanyTypeItems(),
      ],
      statuses: [
        {value: '', text: 'Dowolna'},
        ...getCompanyStatusItems(),
      ],
      rules: {
        textFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 2 || 'Wpisz co najmniej dwa znaki.'
          },
        ],
      },
    };
  },
  created() {
    this.getSupervisors();
    this.filterCompaniesDebouncing = debounce(function () {
      this.filterCompanies();
    }, 500);
  },
  watch: {
    standardFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterCompanies();
      },
      deep: true
    },
    debouncedFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterCompaniesDebouncing();
      },
      deep: true
    },
  },
  methods: {
    filterCompanies() {
      this.$root.$emit('companies.resetPage');
      this.$root.$emit('companies.load', {
        filters: {
          ...this.standardFilters,
          ...this.debouncedFilters,
        },
        onSuccess: () => {
          this.$root.$emit('notify', {
            html: 'Filtrowanie zakończone.',
          });
        }
      });
    },
    onSellWithWmSwitched() {
      if (this.standardFilters.sellWithWm && this.standardFilters.notSellWithWm) {
        this.standardFilters.notSellWithWm = false
      }
    },
    onNotSellWithWmSwitched() {
      if (this.standardFilters.notSellWithWm && this.standardFilters.sellWithWm) {
        this.standardFilters.sellWithWm = false
      }
    },
    async getSupervisors() {
      this.loading = true;

      const response = await api.get('/api/users?role=ROLE_SUPERVISOR', {});
      this.loading = false;

      this.supervisors = [{id: 0, email: "Wybierz opiekuna"}].concat(response.data.items);
    },
  }
}
</script>